var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-reset",attrs:{"type":"button"},on:{"click":_vm.click}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.srText))]),_vm._v(" "),_c('span',{class:_vm.iconClasses})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679f442a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/aha-recipe-box-favorite.vue
// module id = 891
// module chunks = 0